/* global data, serverParams, teamMap, urlPrefix */
import Table from 'bam-node-savant-table/table'
import './arm-swarms/summary-throws'

function format(value) {
    return Number(value) ? Number(value).toFixed(1) : '--'
}

function throwsText(pos) {
    if (!pos) {
        return 'Throws'
    }
    if (pos === 'arm_inf') {
        return '2B/SS/3B Throws'
    }
    return `${pos.slice(4).toUpperCase()} Throws`
}

function throwsField(pos) {
    if (!pos) {
        return 'total_throws'
    }
    return `total_throws_${pos.slice(4)}`
}

const isTeam = serverParams.type === 'team'
const playerOnlyCols = [
    'fielder_name',
    'arm_overall',
    'total_throws',
    'arm_inf',
    'arm_of',
]
const displayIds = ['Annual Fielder Team Summary', 'Total Fielder Team Summary']
const teamIdField =
    displayIds.includes(serverParams.groupCategory) || isTeam
        ? 'fld_team_id'
        : 'fld_team_id_display'

const teamName = 'Team'
const headers = [
    {
        name: 'Player',
        field: 'fielder_name',
        customSortField: 'fielder_name',
        headerClass:
            'th-component-header align-left th-vertical-bottom table-static-column',
        fieldClass: 'tr-data align-left table-static-column',
        photo: '<img class="player-mug" onError="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
        photoId: 'player_id',
        defaultSortDir: 'asc',
        displayFn: (fielder_name, d) =>
            `<a href="/savant-player/${d.player_id}">${fielder_name}</a>`, // what levels of unsafe is this?
    },
    {
        name: teamName,
        field: 'team_name',
        headerClass: `th-component-header align-${isTeam ? 'left' : 'center'}`,
        fieldClass: `tr-data align-${isTeam ? 'left' : 'center'}`,
        photo: '<img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/{1}.svg" onerror="this.onerror=\'\';this.src=\'/site-core/images/savant-mlb.svg\'" />',
        photoId: teamIdField,
        defaultSortDir: 'asc',
        photoOnly: !isTeam,
    },
    {
        name: throwsText(serverParams.pos),
        field: throwsField(serverParams.pos),
        customSortField: throwsField(serverParams.pos),
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data',
        type: 'number',
    },
    {
        name: 'Max',
        field: 'max_arm_strength',
        headerClass:
            'th-component-header align-center th-vertical-bottom border-right',
        fieldClass: 'tr-data border-right',
        displayFn: format,
        type: 'number',
    },
    {
        name: 'Overall',
        field: 'arm_overall',
        headerClass:
            'th-component-header align-center th-vertical-bottom th-vertical-top-strong',
        fieldClass: 'tr-data emphasized-cell',
        displayFn: format,
        type: 'number',
        // NOTE: If these change you'll have to change the league average hardcoded in handlebars.js
        highlight: [75, 85, 95],
    },
    {
        name: '2B/SS/3B',
        field: 'arm_inf',
        headerClass:
            'th-component-header align-center th-vertical-bottom th-vertical-top-strong',
        fieldClass: 'tr-data emphasized-cell',
        displayFn: format,
        type: 'number',
    },
    {
        name: 'OF',
        field: 'arm_of',
        headerClass:
            'th-component-header align-center th-vertical-bottom th-vertical-top-strong border-right',
        fieldClass: 'tr-data emphasized-cell border-right',
        displayFn: format,
        type: 'number',
    },
    {
        name: '1B',
        field: 'arm_1b',
        headerClass:
            'th-component-header align-center th-vertical-bottom border-left',
        fieldClass: 'tr-data',
        displayFn: format,
        type: 'number',
    },
    {
        name: '2B',
        field: 'arm_2b',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data',
        displayFn: format,
        type: 'number',
    },
    {
        name: '3B',
        field: 'arm_3b',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data',
        displayFn: format,
        type: 'number',
    },
    {
        name: 'SS',
        field: 'arm_ss',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data',
        displayFn: format,
        type: 'number',
    },
    {
        name: 'LF',
        field: 'arm_lf',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data',
        displayFn: format,
        type: 'number',
    },
    {
        name: 'CF',
        field: 'arm_cf',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data',
        displayFn: format,
        type: 'number',
    },
    {
        name: 'RF',
        field: 'arm_rf',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data',
        displayFn: format,
        type: 'number',
    },
]

const tableDivId = 'arm_strength_table'
if (data && data.length) {
    const width = document.getElementById(tableDivId).offsetWidth
    let repeatHeader = false
    if (width <= 768) {
        repeatHeader = 15
    }
    const defaultSort = serverParams.sort.column
    const defaultSortDirection = serverParams.sort.direction

    // eslint-disable-next-line no-new
    new Table({
        id: tableDivId,
        repeatHeader,
        headers: headers.filter(
            (h) => !isTeam || !playerOnlyCols.includes(h.field)
        ),
        highlightFalsy: false,
        data: data.map((d) => {
            const teamId = d[teamIdField]
            const teamData = teamMap[teamId]
            return {
                ...d,
                team_name: teamData?.fullName || 'MLB',
            }
        }),
        uniqueId: 'fielder_name', // this can't have dashes in it
        defaultSort,
        defaultSortDirection,
        sortClass: 'column-sort',
        showRank: true,
        sortCallback(column, _, { state }) {
            const url = populateUrl(column, state)
            window.history.replaceState('', '', url)
        },
    })
}

document.querySelectorAll('#leaderboard .form-control').forEach((el) => {
    el.addEventListener('change', (e) => {
        const id = el.getAttribute('id')
        const type = id.slice(3)
        const { selectedIndex } = e.target
        document.querySelector(`.label-change-${type}`).innerText =
            e.target[selectedIndex].text
    })
})

function populateUrl(sortColumn, sortDirection) {
    const parameters = {
        type: document.getElementById('ddlType')?.value || '',
        year: document.getElementById('ddlSeason')?.value || '',
        minThrows: document.getElementById('ddlMinThrows')?.value || '',
        pos: document.getElementById('ddlPos')?.value || '',
        team: document.getElementById('ddlTeam')?.value || '',
    }

    if (sortColumn) {
        parameters.sortColumn = sortColumn
    }
    if (sortDirection) {
        parameters.sortDirection = sortDirection
    }

    const urlParams = new URLSearchParams(parameters)

    return `${urlPrefix}/leaderboard/arm-strength?${urlParams.toString()}`
}

document.getElementById('btn-update').addEventListener('click', () => {
    window.location = populateUrl()
})

document.getElementById('btn-csv').addEventListener('click', () => {
    window.location.href = window.location.search
        ? `${window.location.href}&csv=true`
        : `${window.location.href}?csv=true`
})

let isFixedHeaderShowing = false

window.addEventListener('scroll', () => {
    window.requestAnimationFrame(() => {
        checkHeaderPosition(tableDivId)
    })
})

function checkHeaderPosition(divId) {
    const $el = document.getElementById(divId)
    if (!$el) {
        return
    }
    const { top } = $el.getBoundingClientRect()
    const height = $el.querySelector(`table thead`).offsetHeight
    if (!isFixedHeaderShowing && top < 0) {
        isFixedHeaderShowing = true
        addStaticHeader(divId)
    } else if (isFixedHeaderShowing && top - height > 0) {
        document
            .querySelector(`#${divId} table thead`)
            .classList.remove('fixed-header')
        isFixedHeaderShowing = false
    }
}

/* eslint-disable no-param-reassign */
function addStaticHeader(divId) {
    const $table = document.getElementById(divId)
    const width = $table.offsetWidth

    if (width && width > 767) {
        // Set TH Width before applying fixed-header
        $table
            .querySelector('.default-table-row')
            .querySelectorAll('td')
            .forEach((el) => {
                el.style.width = `${el.offsetWidth}px`
            })

        $table
            .querySelector('.tr-component-row')
            .querySelectorAll('th')
            .forEach((el) => {
                el.style.width = `${el.offsetWidth}px`
            })

        document
            .querySelector(`#${divId} table thead`)
            .classList.add('fixed-header')
    }
}
/* eslint-enable no-param-reassign */
